function getVolume() {
  if (typeof(localStorage) !== "undefined") {
    const volumeValue = localStorage.getItem('volumeValue') ? localStorage.getItem('volumeValue') : 100
    return Number(volumeValue)
  }
}

function setVolume(value) {
  if (typeof(localStorage) !== "undefined") {
    localStorage.setItem('volumeValue', value);
    const volumeEvent = new Event('volumeChanged')
    window.dispatchEvent(volumeEvent);
  }
}

function stopAllAudioExceptSlug(slugToKeepPlaying) {
  if (typeof(window) !== "undefined") {
    const eventData = { detail: { slugPlaying: slugToKeepPlaying } }
    const stopAudioEvent = new CustomEvent('stopAllAudioExcept', eventData)
    window.dispatchEvent(stopAudioEvent);
  }
}

function getCsrfToken() {
  if (typeof(document) !== "undefined") {
    const csrfToken = document.querySelector('[name="csrf-token"]').content
    return csrfToken
  }
}

function triggerSamplesPlayback(shouldPlay) {
  if (typeof(window) !== "undefined") {
    const eventData = { detail: { shouldPlay } }
    const triggerSamplesPlaybackEvent = new CustomEvent('triggerSamplesPlayback', eventData)
    window.dispatchEvent(triggerSamplesPlaybackEvent)
  }
}

export { getVolume, setVolume, stopAllAudioExceptSlug, getCsrfToken, triggerSamplesPlayback }
